import { Box } from '@mui/material';
import { useStore } from 'mobx/StoreContext';
import { observer } from 'mobx-react-lite';
import { PdfViewer } from 'pages/common/IPriseJobs/viewer';
import React from 'react';
import { MASTER_ENDPOINT } from 'utils/Constant';

interface CandidateResumeProps {
  candidateInfo: any;
}

const CandidateResume: React.FC<CandidateResumeProps> = observer(
  ({ candidateInfo }) => {
    const { profileStore } = useStore();
    const userInfo = profileStore.isProfileInfo;
    const finalCandidateId = candidateInfo?.candidate?.id || '';
    const fileName =
      candidateInfo?.candidate?.firstName && candidateInfo?.candidate?.lastName
        ? `${String(candidateInfo.candidate.firstName)} ${String(
            candidateInfo.candidate.lastName,
          )}.pdf`
        : 'Resume.pdf';

    return (
      <Box className="pdf-viewer-wrapper">
        <PdfViewer
          url={`${String(process.env.REACT_APP_APIURL)}${String(
            MASTER_ENDPOINT.Files,
          )}/${String(finalCandidateId)}?type=resume&userId=${String(
            userInfo?.id,
          )}`}
          hideDownload={false}
          fileName={fileName}
          candidateId={finalCandidateId}
        />
      </Box>
    );
  },
);

export default CandidateResume;
